/* src/app/navigation/components/sem-header-menu/sem-header-menu.component.css */
.instructions-help-icon-img {
  background-image: url(/assets/css/images/platform/help-icon.png);
}
/*# sourceMappingURL=sem-header-menu.component.css.map */
